import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["alwaysOpenCheckbox", "hoursSection", "mondayHours", "tuesdayHours", "wednesdayHours", "thursdayHours", "fridayHours", "saturdayHours", "sundayHours"];

  declare readonly alwaysOpenCheckboxTarget: HTMLInputElement;
  declare readonly hoursSectionTarget: HTMLElement;
  declare readonly mondayHoursTarget: HTMLElement;
  declare readonly tuesdayHoursTarget: HTMLElement;
  declare readonly wednesdayHoursTarget: HTMLElement;
  declare readonly thursdayHoursTarget: HTMLElement;
  declare readonly fridayHoursTarget: HTMLElement;
  declare readonly saturdayHoursTarget: HTMLElement;
  declare readonly sundayHoursTarget: HTMLElement;

  toggleAlwaysOpen(event: Event) {
    const input = event.target as HTMLInputElement;
    // A checkbox carries the state itself; a segmented pair of radios reports
    // which one was picked.
    const alwaysOpen = input.type === "radio" ? input.value === "true" : input.checked;

    if (alwaysOpen) {
      this.hoursSectionTarget.classList.add("hidden");
      // Disable all day-specific inputs when always open is checked
      this.disableAllDayInputs();
    } else {
      this.hoursSectionTarget.classList.remove("hidden");
      this.enableAllDayInputs();
    }
  }

  toggleDay(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    const day = checkbox.dataset.day;
    
    if (!day) return;

    const hoursTarget = this.getHoursTargetForDay(day);
    const timeInputs = hoursTarget?.querySelectorAll('input[type="time"]') as NodeListOf<HTMLInputElement>;

    if (checkbox.checked) {
      hoursTarget?.classList.remove("hidden");
      timeInputs?.forEach(input => input.disabled = false);
    } else {
      hoursTarget?.classList.add("hidden");
      timeInputs?.forEach(input => {
        input.disabled = true;
        input.value = '';
      });
    }
  }

  private getHoursTargetForDay(day: string): HTMLElement | null {
    const targetName = `${day}HoursTarget`;
    const target = (this as any)[targetName];
    return target || null;
  }

  private disableAllDayInputs() {
    const dayCheckboxes = this.element.querySelectorAll('input[type="checkbox"][data-day]') as NodeListOf<HTMLInputElement>;
    dayCheckboxes.forEach(checkbox => {
      checkbox.checked = false;
      checkbox.disabled = true;
      this.toggleDay({ target: checkbox } as Event);
    });
  }

  private enableAllDayInputs() {
    const dayCheckboxes = this.element.querySelectorAll('input[type="checkbox"][data-day]') as NodeListOf<HTMLInputElement>;
    dayCheckboxes.forEach(checkbox => {
      checkbox.disabled = false;
    });
  }
}